/** Must stay aligned with integration_hub `llm-pool/constants/llm-providers.ts` (dispatcher adapters). */
export const LLM_PROVIDERS = [
  'vllm',
  'xai',
  'groq',
  'anthropic',
  'openai',
  'gemini',
] as const;

export type LlmProviderId = (typeof LLM_PROVIDERS)[number];

export function isLlmProviderId(value: string): value is LlmProviderId {
  return (LLM_PROVIDERS as readonly string[]).includes(value);
}
